import { connect } from 'react-redux'
import { PANTALLA_ANTERIOR_ID, selectors, actions } from 'ibook-api'
import Pantalla from './pantalla'

const PantallaGameGenerator = connect(
    (state, ownProps) => {
        const configIndice =  selectors.getConfigIndice(state, 'GameGenerator') || { juegos: [] }

        return {
            configIndice
        }
    },
    (dispatch, ownProps) => ({   
        onContinuar: (plantillaId, zonaId, minFC) => dispatch(actions.pantalla('pantalla-game-generator-seleccionar-flashcards', { plantillaId, zonaId, minFC })),
        onTip: () => dispatch(actions.zona('GG', 2, 1)),
        onAtras: () => dispatch(actions.pantalla(PANTALLA_ANTERIOR_ID))
    })
)(Pantalla)

export default PantallaGameGenerator